import React from 'react';
import Bodentemperatur from '../components/Bodentemperatur';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodentemperaturMurau() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodentemperatur-murau-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodentemperatur-murau-heading">BODENTEMPERATUR</h1>
        </div>

        <Bodentemperatur ort="murau" />
      </div>
    </div>
  );
}

export default BodentemperaturMurau;
